import { BulkActions } from '@common/components/Actions/BulkActions';
import { Action, createActions } from '@common/types/actions';
import { Clip } from '@features/Clip';
import { useSelectedCollection } from '@features/Collection/hooks';
import { useCollectionFavorites } from '@features/Collection/hooks/useCollectionFavorites';
import { Collection } from '@features/Collection/types';
import { HeartFilledIcon, HeartIcon, Share2Icon } from '@radix-ui/react-icons';
import { Flex } from '@radix-ui/themes';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

type BlockData = Collection | Clip;

export const ActionsBlock = () => {
    const { selectedCollection } = useSelectedCollection();
    return (
        <ActionsBlockContent
            key={selectedCollection.proscopeId}
            collection={selectedCollection}
        />
    );
};

const ActionsBlockContent = ({ collection }: { collection: Collection }) => {
    const { t } = useTranslation('table'); // todo: update this

    const { checkIsFavorite, toggleFavorite } = useCollectionFavorites();
    const isBookmarked = checkIsFavorite(collection.proscopeId);

    const bulkActions: Action<BlockData>[] = useMemo(
        () =>
            createActions<BlockData>([
                {
                    label: () =>
                        isBookmarked
                            ? t('actions.unbookmark')
                            : t('actions.bookmark'),
                    color: 'gray',
                    icon: () =>
                        isBookmarked ? (
                            <HeartFilledIcon color={undefined} />
                        ) : (
                            <HeartIcon color='gray' />
                        ),
                    onClick: () =>
                        toggleFavorite(collection.proscopeId, !isBookmarked),
                },
                {
                    label: t('actions.export'),
                    onClick: (items) => {
                        console.log('Export these:', items);
                    },
                    color: 'gray',
                    icon: <Share2Icon />,
                },
            ]),

        [isBookmarked, t, collection.proscopeId, toggleFavorite],
    );

    return (
        <Flex gap={'2'} mt={'5'}>
            <BulkActions
                actions={bulkActions}
                selectedItems={[]}
                size={'3'}
                variant='surface'
            />
        </Flex>
    );
};
